
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { jobFormSchema, type JobFormValues } from "../schemas/jobFormSchema";
import { useJobSubmit } from "../hooks/useJobSubmit";
import { JobFormContent } from "../components/JobFormContent";
import { Badge } from "@/components/ui/badge";

interface ManualJobCreationTabProps {
  clientId?: string;
  clientName?: string;
  onSuccess?: () => void;
  onClose: () => void;
}

export function ManualJobCreationTab({ 
  clientId, 
  clientName, 
  onSuccess, 
  onClose 
}: ManualJobCreationTabProps) {
  const form = useForm<JobFormValues>({
    resolver: zodResolver(jobFormSchema),
    defaultValues: {
      status: "open",
    },
  });

  const { onSubmit, isSubmitting } = useJobSubmit({ clientId, onSuccess, onClose });

  return (
    <div className="py-6">
      {clientName && (
        <div className="mb-6">
          <Badge variant="secondary">
            Will be linked to: {clientName}
          </Badge>
        </div>
      )}
      
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
          <JobFormContent form={form} clientName={clientName} />
          
          <div className="flex justify-end gap-2 pt-4 border-t sticky bottom-0 bg-background">
            <Button variant="outline" type="button" onClick={onClose}>
              Cancel
            </Button>
            <Button 
              type="submit" 
              disabled={isSubmitting}
            >
              {isSubmitting ? "Creating..." : "Create Job"}
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}
